import {createListResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const ProviderListItemSchema = z.object({
  email: z.string().nullable(),
  enrollmentDate: z.string().nullable(),
  id: z.string().nullable(),
  mobile: z.string().nullable(),
  name: z.string().nullable(),
  netPoints: z.number().nullable(),
  referedCustomerCode: z.string().nullable(),
  referedCustomerID: z.string().nullable(),
  referralCode: z.string().nullable(),
  savings: z.number().nullable(),
  status: z.number().nullable(),
  storeId: z.string().nullable(),
  storeName: z.string().nullable(),
  surname: z.string().nullable(),
  worth: z.number().nullable(),
  zipCode: z.string().nullable(),
})

export const ProviderListSchemaResponse = createListResponseSchema(ProviderListItemSchema.array())

export type ProviderListItem = z.infer<typeof ProviderListItemSchema>
export type ProviderList = z.infer<typeof ProviderListSchemaResponse.shape.response>
export type ProviderListResponse = z.infer<typeof ProviderListSchemaResponse>

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number(),
    childFilters: z.array(z.object({})),
  })
)

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string(),
  })
)

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
})

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
})

export type ListFilter = z.infer<typeof listFilterSchema>
export type ListerFilterTrx = z.infer<typeof listFilterSchema>
